// @flow

import React from 'react';
import './PickUpLocationInfo.scss';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Utils
import { clickEvent } from 'utils/adaConfigurations/customEvents';

const ns = 'pick-up-location-info';

type Props = {
  dealerContact: Object,
  locale: string,
  intl: IntlShape,
  pickUpAddress: string
};

const PickUpLocationInfo = ({
  dealerContact,
  locale,
  intl,
  pickUpAddress
}: Props) => {
  if (!dealerContact) {
    return <div />;
  }
  const addressDetails = pickUpAddress.split(', ');
  const streetAddressOne = addressDetails[0];
  const remainingAddress = addressDetails
    .slice(1, Math.min(addressDetails.length, 3)) // only selects city and state if these are available
    .join(', ');

  return (
    <div className={ns}>
      <span className={`${ns}__title`}>
        {intl.formatMessage({
          id: 'c8.confirmation.pick.up.location',
          defaultMessage: 'Pick up location'
        })}
      </span>
      <br />
      <address
        className={`${ns}__street`}
        tabIndex={0}
        aria-label={intl.formatMessage({
          id: 'c8.aria.pick.up.map',
          defaultMessage: 'Continue to Pick up location map'
        })}
        onKeyUp={clickEvent}
        onClick={() => {
          window.open(
            `//maps.google.com/maps?daddr=${pickUpAddress}&hl=${locale}`,
            `addressMap`,
            `location=1,status=1,scrollbars=1,width=1024,height=1024`
          );
        }}
      >
        {streetAddressOne}
        <br />
        {remainingAddress}
        <br className="d-none d-md-block" />
      </address>
    </div>
  );
};

export default PickUpLocationInfo;



// WEBPACK FOOTER //
// ./src/components/atoms/PickUpLocationInfo/PickUpLocationInfo.js